export enum StatusComplaintsEnum {
  NEW = "NEW",
  DISPUTE_CALL_CENTER = "DISPUTE_CALL_CENTER",
  CALL_CENTER = "CALL_CENTER",
  TRAFFIC = "TRAFFIC",
  NON_RELEVANT = "NON_RELEVANT",
  CONSIDERATION = "CONSIDERATION"
}